<div class="login-page" [class.has-backdrop]="brand.loginBackground">
  <div class="login-backdrop" *ngIf="brand.loginBackground">
    <picture>
      <source srcset="./assets/background.webp" type="image/webp" />
      <img src="./assets/background.jpg" class="login-bg-image" alt="" decoding="async" fetchpriority="low" />
    </picture>
  </div>

  <div class="login-container">
    <div class="login-card">
      <img
        class="login-logo"
        [src]="brand.logo"
        [alt]="brand.productName"
        decoding="async" />

      <h1 class="login-title">Forgot password</h1>
      <p class="login-subtitle">We will email you a link to set a new password</p>

      <div *ngIf="error" class="alert alert-danger login-error" role="alert">
        <i class="bi bi-exclamation-circle login-error-icon" aria-hidden="true"></i>
        <div class="login-error-body">
          <p class="login-error-text mb-0">{{ error }}</p>
        </div>
      </div>

      <div *ngIf="message" class="alert alert-success login-error" role="alert">
        <i class="bi bi-check-circle login-error-icon" aria-hidden="true"></i>
        <div class="login-error-body">
          <p class="login-error-text mb-0">{{ message }}</p>
        </div>
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form mb-3">
        <div class="form-group">
          <label class="form-label" for="forgot-email">Email</label>
          <input
            id="forgot-email"
            type="email"
            class="form-control"
            formControlName="email"
            autocomplete="email"
            placeholder="you@example.com"
            [class.is-invalid]="submitted && form.get('email')?.invalid" />
          <div class="invalid-feedback d-block" *ngIf="submitted && form.get('email')?.invalid">
            Enter a valid email address.
          </div>
        </div>

        <button type="submit" class="btn btn-primary login-btn" [disabled]="loading">
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
          {{ loading ? 'Sending…' : 'Send reset link' }}
        </button>
      </form>

      <p class="small text-center mb-0">
        <a routerLink="/login">Back to sign in</a>
      </p>
    </div>
  </div>
</div>
